<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    hide-selected
    hide-no-data
    no-filter
    multiple
    chips
    small-chips
    deletable-chips
    item-text="id"
    item-value="id"
    label="Item de cotação"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @focus="onFocus"
    v-bind="$attrs"
  >
    <template v-slot:item="item">
      <v-list-item-content>
        <v-list-item-title>
          <px-chip-codigo-interno :codigo-interno="item.item.produto.codigo"/>
          {{
            descricaoProduto(item.item)
          }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ especificacaoProduto(item.item) }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>
    <template v-slot:selection="item">
      <div class="truncate-text">
        <px-chip-codigo-interno :codigo-interno="item.item.produto.codigo"/>
        {{ descricaoProduto(item.item) }}
        <v-btn small icon @click="onRemoveItem(item.index)">
          <v-icon small class="mb-1">mdi-close</v-icon>
        </v-btn>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import CotacaoProdutoService from '@/api/cotacao-produto-service';

export default {
  props: {
    value: Array,
    path: {
      type: String,
      default: null,
    },
    cotacoes: Array,
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
    descricaoProduto() {
      return item => (item.produto.isGenerico
        ? item.especificacaoProduto : item.produto.descricao);
    },
    especificacaoProduto() {
      return item => (item.produto.isGenerico ? null : item.especificacaoProduto);
    },
  },
  watch: {
    search(val) {
      if (!val || (this.localValue && this.localValue.descricao === val)) return;
      this.debounceSearch(val);
    },
  },
  methods: {
    onRemoveItem(index) {
      this.localValue.splice(index, 1);
      this.$emit('input', this.localValue);
    },
    getCotacoes() {
      if (!this.cotacoes || !this.cotacoes.length) {
        return [];
      }
      return this.cotacoes.map(cot => cot.id).join(',');
    },
    buildFilter(val) {
      const text = val || '';
      let filter = `(descricao like "%${text.toLowerCase()}%" or especificacaoProduto like "%${text.toLowerCase()}%" or codigoInterno like "%${text.toLowerCase()}%") and ativo is true`;
      if (this.value && this.value.length) {
        const ids = this.value.map(cot => cot.id)
          .join(' and id != ');
        filter = `${filter} and id != ${ids}`;
      }
      return filter;
    },
    searchProdutos(val) {
      this.loading = true;
      CotacaoProdutoService.getCotacoesProdutos(this.path, {
        cotacoes: this.getCotacoes(),
        query: this.buildFilter(val),
      })
        .then((response) => {
          this.items = response.data;
          if (this.value && this.value.length) {
            this.items = [...this.items, ...this.value];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onFocus() {
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchProdutos, 1000);
    if (this.value && this.value.length) {
      this.items = [...this.items, ...this.value];
    }
  },
};
</script>
